import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { VertexInteractionPoint, WorkflowEdge, WorkflowVertex } from 'component.workflow.core';

@Component({
  selector: 'wf-designer-vertex-connection',
  template: `

    <div class="connection">

      <span class="name">{{ vertex.name }}
        <span *ngIf="isEdgeNamed">
          → {{edgeName}}
        </span>
      </span>

      <div class="actions">
        <a href="javascript:;" title="Move Up" (click)="moveUp()">▲</a>
        <a href="javascript:;" title="Move Down" (click)="moveDown()">▼</a>
      </div>

      <div style="width: 1rem">&nbsp;</div>

      <button type="button" (click)="remove()" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>

    </div>

  `,
  styles: [`
    .connection {
      display: flex;
    }

    .connection .name {
      flex: 1;
    }

    .connection button {
      font-size: 1.2rem;
      color: #f00;
    }

  `]
})
export class WorkflowDesignerVertexConnectionComponent implements OnChanges {

  @Input() edge: WorkflowEdge;
  @Input() direction: string;

  @Output() removed = new EventEmitter<WorkflowEdge>();
  @Output() moved = new EventEmitter<{ edge: WorkflowEdge, steps: number, direction: string }>();

  constructor() {

  }

  get vertex(): WorkflowVertex {
    return this.direction === 'in' ? this.edge.fromVertex : this.edge.toVertex;
  }

  get isEdgeNamed(): boolean {
    return this.direction === 'in' ? this.getPointNamed(this.edge.fromOutlet) : this.getPointNamed(this.edge.toInlet);
  }

  get edgeName(): string {
    return this.direction === 'in' ? this.getPointName(this.edge.fromOutlet) : this.getPointName(this.edge.toInlet);
  }

  getPointNamed(point: VertexInteractionPoint): boolean {

    if (!point) {
      return false;
    }

    return point.named;
  }

  getPointName(point: VertexInteractionPoint) {

    if (!point) {
      return '';
    }

    return point.named ? point.name : '✸';
  }

  moveUp() {
    this.moved.emit({
      edge: this.edge,
      steps: -1.5,
      direction: this.direction
    });
  }

  moveDown() {
    this.moved.emit({
      edge: this.edge,
      steps: 1.5,
      direction: this.direction
    });
  }

  remove() {
    this.removed.emit(this.edge);
  }

  ngOnChanges() {

  }
}



// WEBPACK FOOTER //
// ./src/library/designer/vertex/workflow-designer-vertex-connection.component.ts